import { makeEntityScaffold } from '@classpass/saga-tools';
import { isEmpty } from 'helpers/verify';
import { SearchLayout } from 'features/Search/models/SearchLayout';

export const searchSchedules = makeEntityScaffold(
  'SAGA.API.SEARCH_SCHEDULES',
  (client, options = {}) =>
    options.cursor ? client.search.getSchedulesByCursor(options) : client.search.schedules(options),
  {
    defaultKey: (client, options) => (options.page ? `page_${options.page}` : 'page_1'),
  }
);

export const keywordAutocomplete = makeEntityScaffold(
  'SAGA.API.KEYWORD_AUTOCOMPLETE',
  (client, query, location) =>
    client.search.keyword
      .autocomplete({
        query,
        location,
      })
      .then(data => data.data.results),
  { defaultKey: 1 }
);

export const locationAutocomplete = makeEntityScaffold(
  'SAGA.API.LOCATION_AUTOCOMPLETE',
  (client, query) => client.search.location.autocomplete({ query }),
  { defaultKey: 1 }
);

export const searchLayoutByName = makeEntityScaffold(
  'SAGA.API.SEARCH_LAYOUT',
  (client, layoutName, payload = {}, config = {}) =>
    client.search.getLayout(layoutName, payload).then(
      ({ data: { modules } }) =>
        new SearchLayout(modules, {
          layoutName,
          distanceUnit: config.distanceUnit,
        })
    ),
  { defaultKey: 1 }
);

export const searchLocationAutocomplete = makeEntityScaffold(
  'SAGA.API.SEARCH_LOCATION_AUTOCOMPLETE',
  (client, { query, near, type = 'geocode' } = {}) =>
    client.search.location
      .autocomplete({
        autocomplete_type: type,
        near: isEmpty(near)
          ? null
          : {
              lat: near.lat,
              lon: near.lon,
            },
        query,
      })
      .then(data => data.data)
);

export const searchLocationDetails = makeEntityScaffold(
  'SAGA.API.SEARCH_LOCATION_DETAILS',
  (client, placeId) => client.search.location.details(placeId).then(data => data.data),
  { defaultKey: 1 }
);
